/* eslint-disable tailwindcss/no-arbitrary-value */
import * as RadixDialog from '@radix-ui/react-dialog';
import { cn } from '@ui/lib';

const Overlay = ({ className, ...props }: RadixDialog.DialogOverlayProps) => (
  <RadixDialog.Overlay
    {...props}
    className={cn(
      'bg-screen-surface-dark/disabled fixed inset-none z-40',
      className,
    )}
  />
);

const Content = ({ className, ...props }: RadixDialog.DialogContentProps) => (
  <RadixDialog.Content
    {...props}
    className={cn(
      'fixed left-1/2 top-1/2 z-50 max-h-[85%] w-10/12 max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-primary-surface p-card-padding-large shadow outline-none',
      className,
    )}
  />
);

const Title = ({ className, ...props }: RadixDialog.DialogTitleProps) => (
  <RadixDialog.Title {...props} className={cn(className)} />
);

export {
  Close,
  Description,
  Portal,
  Root,
  Trigger,
} from '@radix-ui/react-dialog';
export { Content, Overlay, Title };
